export default __webpack_public_path__ + "static/media/keyvisual-goettingen.e55a2a12.jpg";